/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_TitleInputs */



/**
* | output |
* | --- |
* | "Custom Tag Manager" |
*
* @param {Tags_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_title = /** @type {((inputs?: Tags_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestionnaire de tags personnalises")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdefinierter Tag-Manager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestore tag personalizzato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер пользовательских тегов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrador de etiquetas personalizado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自定义标签管理器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタムタグマネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कस्टम टैग मैनेजर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciador de tags personalizadas")
	return /** @type {LocalizedString} */ ("Custom Tag Manager")
});